import VocResultTable from "./components/VocResultTable";

const VocResult = () => {
  return <VocResultTable />;
};

export default VocResult;
